// AppContext.js
import React, { createContext, useReducer, useContext } from 'react';

// Define the initial state
const initialState = {
  // Your initial state properties go here
  isLoggedIn: false, // Adding an example authentication-related state
  isCategoryUpdated: true, // Adding an example authentication-related state
  sideBarHeading: '',
};

// Create the context
const AppContext = createContext();

// Create a reducer function
const appReducer = (state, action) => {
  switch (action.type) {
    case 'SET_AUTH_STATUS':
      return { ...state, isLoggedIn: action.payload };
    case 'CAT_UPDATED':
      return { ...state, isCategoryUpdated: action.payload };
    case 'SIDEBAR_HEADING':
      return { ...state, sideBarHeading: action.payload };
    // Handle other action types as needed
    default:
      return state;
  }
};

// Create a provider component
const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

// Create a custom hook to use the context
const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

export { AppProvider, useAppContext };
